// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    API_URL: '',
    baseUrl: '',
    login: '/user/login',

    client: 'ironside', // A MODIFIER POUR CHAQUE ENV
    MSclientID: '',
    MStenantID: '',
    MSredirectUri: '',
    facebook_url: '',
    linkedin_url: '',
    twitter_url: '',
    instagram_url: '',
    youtube_url: '',
    logo: '/assets/logo/logo_ironside.png',
    hideSocials: false,
    tramValidationMailList: '',
    tramValidationEmailTemplate: '',
    // samlConfig: {
    //   entryPoint: 'https://sts.windows.net/a525bbbb-a427-466a-bb2f-98ff8340ab60/',
    //   issuer: 'https://sts.windows.net/a525bbbb-a427-466a-bb2f-98ff8340ab60/',
    //   callbackUrl: 'https://devischef-v2.geolane.fr/login',
    //   cert: `MIIC8DCCAdigAwIBAgIQM/Frg5Hx7Z5HLVocsVAn2TANBgkqhkiG9w0BAQsFADA0MTIwMAYDVQQDEylNaWNyb3NvZnQgQXp1cmUgRmVkZXJhdGVkIFNTTyBDZXJ0aWZpY2F0ZTAeFw0yMzA0MDcxNDA0NDBaFw0yNjA0MDcxNDA0MzlaMDQxMjAwBgNVBAMTKU1pY3Jvc29mdCBBenVyZSBGZWRlcmF0ZWQgU1NPIENlcnRpZmljYXRlMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxnU6t7OEhZQe2A8J3j4GEq/jw915kPhEv6N8hxNz7yAy7G8uwWNdY7ARYoQnK15IIMgqDg1O0srFX7rtC4tvgWDS5pG9qd2sjqjHojGxptRgmPbK86SS0sUJSFvSI/HqyNl0w7mq8JIu/6nDQreiXmPcLX1hJ7nxjN4hlGwboGLEOUWHai0fxFLd2AWWzqb/2HNhnyBJF+txVwtwUmt3r4+0pq2kksYtFZlhX77krsO13RAd/ZHh5krA6bU9qY3gdLCsPHDS0LmuMpxOR5kgoPnvEXcJqpfnJNyg2JKPKeCGvboG4p2ayU1utaZK+POGydXgy4tzQzO+xZGtk80aNQIDAQABMA0GCSqGSIb3DQEBCwUAA4IBAQAL3H/2pEdxpAUWQxMI6iRa5/7KCnj/DgyvTvucMWq5yUqrFHYPqB/lN+T8Wqg7xwnrVHcbPSunuw3b2UHOW08ieXMEMAxFwNm30jSS4hVrf7hxvKxBYz5yPho+0KJcJ1tga9cefc90P7snBDAQ0PY0qYy5ZLykK/tFABCiV2sSK2jUqiBsgslWaUfmy/aUi0Cb+6AJdG3gr/zmkpXHQC44YJ02RKeXfKPRKX8l8IRGyGil9KTxRN8GpVIH4xLlj53Gcu5Dq46GXG21m+XoHNlT/coRja27k2KeLs32APsEdkfJOvAom/9sbjeU6NL6zgc3g/5ZD7sOjNzHMEkiYDl0`,
    // },

    wsURL: '',
    //wsURL: 'wss://www.ironsideinternational.com/ws',
    domain_prod: 'https://www.ironsideinternational.com',
    domain_dev: 'https://dev-ironside-elliance.geolane.fr',

    languages: [
        { code: 'fr', locale: 'fr_FR', text: 'Français' },
        { code: 'en', locale: 'en_GB', text: 'Anglais' },
        { code: 'es', locale: 'es_ES', text: 'Espagnol' },
        { code: 'de', locale: 'de_DE', text: 'Allemand' },
        { code: 'nl', locale: 'nl_NL', text: 'Néerlandais' },
        { code: 'da', locale: 'da_DK', text: 'Danois' },
        { code: 'sv', locale: 'sv_SE', text: 'Suédois' },
        { code: 'fi', locale: 'fi_FI', text: 'Finlandais' },
        { code: 'nn', locale: 'nn_NO', text: 'Norvégien' },
        { code: 'it', locale: 'it_IT', text: 'Italien' },
    ],

    languagesExtranet: [
        { code: 'en', locale: 'en_GB', text: 'Anglais' },
        { code: 'fr', locale: 'fr_FR', text: 'Français' },
        { code: 'es', locale: 'es_ES', text: 'Espagnol' },
        { code: 'de', locale: 'de_DE', text: 'Allemand' },
        { code: 'nl', locale: 'nl_NL', text: 'Néerlandais' },
        { code: 'da', locale: 'da_DK', text: 'Danois' },
        { code: 'sv', locale: 'sv_SE', text: 'Suédois' },
        { code: 'fi', locale: 'fi_FI', text: 'Finlandais' },
        { code: 'nn', locale: 'nn_NO', text: 'Norvégien' },
        { code: 'it', locale: 'it_IT', text: 'Italien' },
    ],
};
